module.exports = __webpack_public_path__ + "static/nice_snow-96a3ec2fe2fcbc4ba2e2fe53f32b0bbc.png";